module.exports = "./img/desktop_logo.d3f00cd.png";